var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "resources-app" } },
    [
      _vm.featureFlags.learning_centre
        ? _c("learning-center-section")
        : _vm._e(),
      _vm._v(" "),
      _vm.featureFlags.newsletter ? _c("newsletter-section") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/components/ResourcesApp.vue